export default {
  methods: {
    iconForUserFile(mimeType) {
      // FontAwesome / MimeType mapping based on:
      // https://gist.github.com/colemanw/9c9a12aae16a4bfe2678de86b661d922
      var icon_classes = {
        // Media
        image: "fa-file-image",
        audio: "fa-file-audio",
        video: "fa-file-video",
        // Documents
        "application/pdf": "fa-file-pdf",
        "application/msword": "fa-file-word",
        "application/vnd.ms-word": "fa-file-word",
        "application/vnd.oasis.opendocument.text": "fa-file-word",
        "application/vnd.openxmlformats-officedocument.wordprocessingml": "fa-file-word",
        "application/vnd.ms-excel": "fa-file-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml": "fa-file-excel",
        "application/vnd.oasis.opendocument.spreadsheet": "fa-file-excel",
        "application/vnd.ms-powerpoint": "fa-file-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml": "fa-file-powerpoint",
        "application/vnd.oasis.opendocument.presentation": "fa-file-powerpoint",
        "text/plain": "fa-file-alt",
        "text/html": "fa-file-code",
        "application/json": "fa-file-code",
        // Archives
        "application/gzip": "fa-file-archive",
        "application/zip": "fa-file-archive"
      }

      for (var key in icon_classes) {
        if (Object.prototype.hasOwnProperty.call(icon_classes, key)) {
          if (mimeType.search(key) === 0) {
            // Found it
            return icon_classes[key];
          }
        } else {
          return "fa-file";
        }
      }
      return 'fa-file'
    },

    descriptionForUserFileMimeType(mimeType, filename) {
      mimeType = ('' + mimeType).trim().toLowerCase()
      filename = ('' + filename).trim().toLowerCase()

      var lookupMap = {
        image: 'Image',
        audio: 'Audio',
        video: 'Video',
        'application/pdf': 'Document'
      }

      for (var key in lookupMap) {
        if (Object.prototype.hasOwnProperty.call(lookupMap, key)) {
          if (mimeType.search(key) === 0) {
            // Found it
            return lookupMap[key];
          }
        }
      }

      // Check extension on filename
      if(filename.endsWith('.dxf'))
        return 'AutoCAD DXF'

      return 'Unknown'
    }
  }
}
